const stateKeys = ['budgetDetail']

export const actions = {
  clearSettings() {
    for (let ix = 0; ix < stateKeys.length; ix++) {
      this.$storage.removeUniversal(stateKeys[ix])
    }
  },
  async getData({ dispatch }) {
    let data = await this.$apiAaltra.settingsEnergyBudget()

    if (data && !data.start) {
      data = null
    }
    dispatch('setBudgetDetail', { budget: data, reset: true })

    const listData = data
      ? [
          {
            title: this.app.i18n.t('budget'),
            text: `${this.$formatEpochToShortDate(data.start)} - ${
              data.end
                ? this.$formatEpochToShortDate(data.end)
                : this.app.i18n.t('present')
            }`,
            route: {
              name: 'energy-settings-budget-detail'
            }
          }
        ]
      : []

    return listData
  },
  async setBudgetDetail({ dispatch }, { budget, reset }) {
    if (!budget) {
      this.$storage.removeUniversal('budgetDetail')
    } else {
      let oldBudget = await dispatch('getBudgetDetail')
      if (reset) {
        oldBudget = {}
      }
      await this.$storage.setUniversal('budgetDetail', {
        ...oldBudget,
        ...budget
      })
    }
  },
  getBudgetDetail() {
    return this.$storage.getUniversal('budgetDetail')
  },
  async getBudgetOverview({ dispatch }) {
    const budgetDetail = await dispatch('getBudgetDetail')

    const budgetOverview = []
    let energyBudget = null
    let heatLoadCalculation = null
    let electricityUsage = null
    let heatUsage = null

    if (!budgetDetail) return budgetOverview

    energyBudget = [
      {
        text: [
          this.app.i18n.t('renovationOrNewBuild'),
          budgetDetail.renovation
            ? this.app.i18n.t('renovated')
            : this.app.i18n.t('newBuild')
        ]
      }
    ]

    budgetOverview.push({
      label: this.app.i18n.t('energyBudget'),
      rows: energyBudget
    })

    if (budgetDetail.renovation) {
      // Display electricity usage when it's a renovation
      electricityUsage = [
        {
          text: [
            this.app.i18n.t('electricityUsageQuestion'),
            budgetDetail['electricity-usage']
              ? this.app.i18n.t('yes')
              : this.app.i18n.t('no')
          ]
        }
      ]

      if (budgetDetail['electricity-usage']) {
        electricityUsage.push({
          text: [
            budgetDetail['electricity-kwh-based']
              ? this.app.i18n.t('yearlyUsage')
              : this.app.i18n.t('yearlyCost'),
            `${budgetDetail['electricity-usage']} ${
              budgetDetail['electricity-kwh-based']
                ? this.app.i18n.t('kwh')
                : this.$currency.get()
            }`
          ]
        })
      }

      budgetOverview.push({
        label: this.app.i18n.t('electricityUsage'),
        rows: electricityUsage
      })

      // Display heat usage when it's a renovation
      const hasOilOrGas = !!(
        budgetDetail['oil-consumption'] || budgetDetail['gas-consumption']
      )

      heatUsage = [
        {
          text: [
            this.app.i18n.t('heatUsageQuestion'),
            hasOilOrGas ? this.app.i18n.t('yes') : this.app.i18n.t('no')
          ]
        }
      ]

      if (hasOilOrGas) {
        const isOil = !!budgetDetail['oil-consumption']
        heatUsage.push({
          text: [
            this.app.i18n.t('typeOfFuel'),
            isOil ? this.app.i18n.t('oil') : this.app.i18n.t('gas')
          ]
        })

        if (isOil) {
          heatUsage.push({
            text: [
              this.app.i18n.t('yearlyUsage'),
              `${budgetDetail['oil-consumption']} ${
                budgetDetail['oil-kwh-based']
                  ? this.app.i18n.t('kwh')
                  : this.app.i18n.t('litres')
              }`
            ]
          })
        } else {
          heatUsage.push({
            text: [
              this.app.i18n.t('yearlyUsage'),
              `${budgetDetail['gas-consumption']} ${
                budgetDetail['gas-kwh-based']
                  ? this.app.i18n.t('kwh')
                  : this.app.i18n.t('cubicMeter')
              }`
            ]
          })
        }

        heatUsage.push({
          text: [
            this.app.i18n.t('peopleLivingInHouse'),
            this.$peopleInHouse(
              budgetDetail.adults || 0,
              budgetDetail.children || 0
            )
          ]
        })

        heatUsage.push({
          text: [
            this.app.i18n.t('containsDomesticHotWater'),
            budgetDetail['dhw-included']
              ? this.app.i18n.t('yes')
              : this.app.i18n.t('no')
          ]
        })
      }

      budgetOverview.push({
        label: this.app.i18n.t('heatUsage'),
        rows: heatUsage
      })
    }

    // New build => heat load calculation
    // No gas or oil consumption => heat load calculation
    if (
      !budgetDetail.renovation ||
      !(budgetDetail['oil-consumption'] || budgetDetail['gas-consumption'])
    ) {
      heatLoadCalculation = this.$heatLoadCalculationOverview(budgetDetail)
      budgetOverview.push({
        label: this.app.i18n.t('heatLoadCalculation'),
        rows: heatLoadCalculation
      })
    }

    return budgetOverview
  },
  async saveData(_, { budgetSettings }) {
    await this.$apiAaltra.updateSettingsEnergyBudget(budgetSettings)
  }
}
